import FormBuilder from './FormBuilder';

export default {
  install(Vue, options) {
    Vue.component('form-builder', FormBuilder);
  }
};
